import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/kakobuy";

const col1 = categories.slice(0, 5);
const col2 = categories.slice(5, 10);
const col3 = categories.slice(10, 14);

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col md:flex-row items-start justify-between gap-10 mb-14">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-white tracking-tight cursor-pointer">
              kakobuy<span className="text-primary-400">.one</span>
            </Link>
            <p className="text-sm text-foreground-300 mt-3 max-w-xs">
              Platforma informacyjna — nie sprzedajemy produktów.
              Znajdziesz tu przewodniki, listy produktów i porady zakupowe.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-8 md:gap-12">
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Kategorie 1-5</h4>
              <div className="flex flex-col gap-2">
                {col1.map((cat) => (
                  <a
                    key={cat.nameEn}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Kategorie 6-10</h4>
              <div className="flex flex-col gap-2">
                {col2.map((cat) => (
                  <a
                    key={cat.nameEn}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Kategorie 11-14</h4>
              <div className="flex flex-col gap-2">
                {col3.map((cat) => (
                  <a
                    key={cat.nameEn}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 border-t border-foreground-700/40 pt-10">
          <div className="flex-1">
            <p className="text-3xl md:text-4xl font-heading italic text-foreground-300">
              © 2026 kakobuy.one
            </p>
            <p className="text-xs text-foreground-400 mt-1">Wszelkie prawa zastrzeżone.</p>
          </div>

          <div className="flex flex-col gap-2">
            <Link to="/artykul/kakobuy-spreadsheet-przewodnik" className="text-xs text-foreground-300 hover:text-white transition-colors cursor-pointer">
              Przewodnik SEO
            </Link>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-300 hover:text-white transition-colors cursor-pointer">
              kaspreadsheet.com
            </a>
            <div className="flex items-center gap-4 mt-2">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-6 h-6 flex items-center justify-center text-foreground-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-6 h-6 flex items-center justify-center text-foreground-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-6 h-6 flex items-center justify-center text-foreground-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <p className="text-[11px] text-foreground-400 mt-8 leading-relaxed max-w-3xl">
          <strong>Zastrzeżenie:</strong> kakobuy.one jest wyłącznie stroną informacyjną. Nie sprzedajemy produktów,
          nie przetwarzamy płatności ani nie pośredniczymy w transakcjach. Wszystkie linki zewnętrzne prowadzą do
          niezależnych serwisów. Użytkownicy dokonują zakupów na własną odpowiedzialność. Zawsze sprawdzaj
          wiarygodność sprzedawcy przed dokonaniem transakcji.
        </p>
      </div>
    </footer>
  );
}